import _slicedToArray from "/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from 'react';
import { TextInputWithFloatingLabelContext } from './text-input.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';
var TextInputWithFloatingLabel = renderWithRef('TextInputWithFloatingLabel', null, function (props, ref) {
  var children = props.children;
  var classes = ['swan-vanilla-ignore', 'swan-input-with-floating-label'];

  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      inputId = _React$useState2[0],
      setInputId = _React$useState2[1];

  var _React$useState3 = React.useState(),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      inputElem = _React$useState4[0],
      setInputElem = _React$useState4[1];

  return /*#__PURE__*/React.createElement(TextInputWithFloatingLabelContext.Provider, {
    value: {
      inputId: inputId,
      setInputId: setInputId,
      inputElem: inputElem,
      setInputElem: setInputElem
    }
  }, /*#__PURE__*/React.createElement(RenderComp, {
    root: "div",
    forwardedRef: ref,
    props: props,
    classNames: classes
  }, children));
});
export { TextInputWithFloatingLabel };